module.exports = __webpack_public_path__ + "img/check-1.88f635b0.svg";